/* eslint-disable @typescript-eslint/camelcase */
import { call, put, all, takeLatest, debounce } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { fetchProfiles, fetchProfileInfo, validateProfile, updateProfile, saveProfile } from '../../api/profile'
import {
  ProfileActions,
  FETCH_PROFILES,
  FETCH_PROFILE_INFO,
  START_PROFILE_VALIDATION,
  START_SAVING_PROFILE
} from './actions'
import { ProfileValidationResult, Profile } from './types'
import { PROFILES } from '../../routes'

const VALIDATION_DEBOUNCE_TIME = 250

export function* loadProfiles(action: ReturnType<typeof ProfileActions.fetchAllProfiles>) {
  try {
    const { limit, offset, sid, appearance, age, hair, breast, skin, size } = action.payload
    const { data } = yield call(fetchProfiles, limit, offset, sid, appearance, age, hair, breast, skin, size)
    yield put(ProfileActions.fetchProfilesSuccess(data.data, data.total))
  } catch (err) {
    // eslint-disable-next-line no-console
    yield console.log(err)
  }
}

export function* loadProfileInfo(action: ReturnType<typeof ProfileActions.fetchProfileInfo>) {
  try {
    const { profileId, sid } = action.payload
    const { data } = yield call(fetchProfileInfo, sid, profileId)
    yield put(ProfileActions.fetchProfileInfoSuccess(data.data))
  } catch (err) {
    // eslint-disable-next-line no-console
    yield console.log(err)
  }
}

export function* validateNewProfile(action: ReturnType<typeof ProfileActions.startProfileValidation>) {
  const { profile } = action.payload
  const { data }: { data: ProfileValidationResult } = yield call(validateProfile, profile)
  yield put(ProfileActions.updateProfileValidation(data))
}

export function* savingProfile(action: ReturnType<typeof ProfileActions.startSavingProfile>) {
  const { profile } = action.payload
  let data: Profile | null = null
  if (profile.id) {
    const response = yield call(updateProfile, profile.id, profile)
    data = response.data
  } else {
    const response = yield call(saveProfile, profile)
    data = response.data
  }
  if (data) {
    yield put(ProfileActions.savingProfileSuccess(data))
    // yield put(HookActions.resetNewHook())
    yield put(push(PROFILES))
  }
}

export function* rootSaga() {
  yield all([
    takeLatest(FETCH_PROFILES, loadProfiles),
    takeLatest(FETCH_PROFILE_INFO, loadProfileInfo),
    takeLatest(START_SAVING_PROFILE, savingProfile),
    debounce(VALIDATION_DEBOUNCE_TIME, START_PROFILE_VALIDATION, validateNewProfile)
  ])
}
